module.exports = function getResource(label, vars = []) {
    const resources = {
        editProfile: 'Edit Profile',
        profileCategories: [
            'Photos & Bio',
            'Skin',
            'Hair',
            'Eyes',
            'Color IQ',
            'Birthday',
            'Privacy'
        ]
    };
    return resources[label];
};
